import React, { PureComponent } from 'react';
import Proptypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeModal } from 'actions/modal';

import { Row, Col, FlexView, COLORS } from '@cuemath/comps';
import { Button, Separator, Text } from '@cuemath/web-comps';
import { MODAL_CONFIRMATION_ACTIONS } from 'constants/form';

class FormContainer extends PureComponent {
  static propTypes = {
    actions: Proptypes.shape({
      closeModal: Proptypes.func.isRequired,
    }).isRequired,
    onConfirm: Proptypes.func.isRequired,
  };

  handleCancel = () => {
    const { actions, onConfirm } = this.props;

    actions.closeModal();
    onConfirm(MODAL_CONFIRMATION_ACTIONS.CANCEL);
  };

  handleConfirm = () => {
    const { actions, onConfirm } = this.props;
    actions.closeModal();
    onConfirm(MODAL_CONFIRMATION_ACTIONS.CONFIRMED);
  };

  render() {
    const { title, description } = this.props;

    return (
      <>
        <Separator height={20} transparent />
        <FlexView gutter={16} justifyContent="center">
          <Text align="center" variant="body1Medium">
            {title ? title : 'Are you sure?'}
          </Text>
          {description && (
            <>
              <Separator height={8} />
              <Text align="center" variant="body2" color={COLORS.GRAY_LIGHT}>
                {description}
              </Text>
            </>
          )}
        </FlexView>
        <Separator height={40} transparent />
        <Row justifyContent="center">
          <Col gutter={8}>
            <Button
              variant="secondary"
              size="small"
              label="Cancel"
              onClick={this.handleCancel}
              width="180px"
            />
          </Col>
          <Col gutter={8}>
            <Button
              width="180px"
              label="Confirm"
              size="small"
              onClick={this.handleConfirm}
            />
          </Col>
        </Row>
        <Separator height={20} transparent />
      </>
    );
  }
}

export default connect(null, dispatch => ({
  actions: bindActionCreators({ closeModal }, dispatch),
}))(FormContainer);
